/**
 * 描述：租户管理--新建编辑弹框
 * 日期：2017-11-16
 * 作者：liu_jinming
 */
"use strict";
angular.module("createEditServiceModule", ['tManageMentServiceModule'])
    .controller("createEditServiceCtrl", ["$scope", "$modalInstance", "trsHttpService", "item", "modalDialog", "$validation", function($scope, $modalInstance, trsHttpService, item, modalDialog, $validation) {
        initStatus();
        initData();
        /** [initStatus description]初始化状态 */
        function initStatus() {
            $scope.status = {
                serviceTitlt: '',
                STATUS: 1,
                showBtn: true,
                nameDisabled: false
            };
            $scope.data = {
                serviceName: '', //服务名称
                serviceDec: '', //服务描述
            };
        }
        /** [initData description] 初始化数据 */
        function initData() {
            if (item.item === undefined) {
                $scope.status.serviceTitlt = '新建服务';
            } else {
                $scope.status.nameDisabled = true;
                if (item.num === 1) {
                    $scope.status.serviceTitlt = "服务详情";
                    $scope.status.showBtn = false;
                } else {
                    $scope.status.serviceTitlt = "编辑服务";
                }
                $scope.data.serviceName = item.item.SERVICENAME;
                $scope.data.serviceDec = item.item.SERVICEDETIA;
                $scope.status.STATUS = item.item.STATUS;
            }
        }
        /** [funciton description]确定按钮执行的操作 */
        $scope.confirm = function() {
            $validation.validate($scope.createEditService).success(function() {
                if (item.item === undefined) {
                    createService();
                } else {
                    editSercive();
                }
            }).error(function() {
                modalDialog.alertType("请检查填写项!", "", "warning", false);
            });
        };
        /** [cancel description] 取消操作 */
        $scope.cancel = function() {
            // if (item.num === undefined) {
            //     modalDialog.alertType("是否关闭当前编辑窗口!", "", "ask", true, function() {
            //         $modalInstance.dismiss();
            //     });
            // } else {
            $modalInstance.dismiss();
            // }
        };
        /** [cancelb description]直接取消 */
        $scope.cancelb = function() {
            $modalInstance.dismiss();
        };
        /** [changeStatus description]改变状态 */
        $scope.changeStatus = function(item) {
            if (!$scope.status.showBtn) return;
            if (item === 1) {
                $scope.status.STATUS = 1;
            } else {
                $scope.status.STATUS = 0;
            }
        };
        /** [changeNewStatus description]选择服务新建时的状态 */
        $scope.changeNewStatus = function(item) {
            if (item === 1) {
                $scope.status.STATUS = 1;
            } else {
                $scope.status.STATUS = 0;
            }
        };
        /** [createService description]新建服务的操作 */
        function createService() {
            var params = {
                serviceid: "mlf_tenant",
                methodname: "newService",
                SERVICENAME: $scope.data.serviceName,
                SERVICEDETAIL: $scope.data.serviceDec,
                STATUS: $scope.status.STATUS
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.TYPE == '3') {
                    modalDialog.alertType("新建成功!", "", "success", false);
                    $modalInstance.close("success");
                } else {
                    modalDialog.alertType("新建失败请再次尝试!", "", "error", "confirm");
                }
            });
        }
        /** [edit description]编辑服务的操作 */
        function editSercive() {
            var params = {
                serviceid: "mlf_tenant",
                methodname: "editService",
                SERVICENAME: $scope.data.serviceName,
                SERVICEDETAIL: $scope.data.serviceDec,
                SERVICECONFID: item.item.SERVICECONFIGID,
                STATUS: $scope.status.STATUS
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.TYPE == '3') {
                    modalDialog.alertType("修改成功!", "", "success", false);
                    $modalInstance.close("success");
                } else {
                    modalDialog.alertType("修改失败请再次尝试!", "", "error", "confirm");
                }
            });
        }
    }]);